import React from 'react';
import { Modal } from 'react-bootstrap';

export default function SelectNoPanelTypeModalGrommet({
  pageLanguage,
  modals,
  modalHandleClose,
  t,
}) {
  return (
   <Modal
   dialogClassName={`noMount_modal mediumSizeModal ${
     pageLanguage === "fa" ? "font_farsi" : "font_en"
   }`}
   show={modals["noPanelType"] === undefined ? false : modals["noPanelType"]}
   onHide={() => modalHandleClose("noPanelType")}
 >
   <Modal.Header closeButton></Modal.Header>
   <Modal.Body>
     <p>{t("modal_select_noPanelType")}</p>

     <br />
     <div className=" text_center">
       <button className=" btn btn-new-dark" onClick={() => modalHandleClose("noPanelType")}>
         {t("CONTINUE")}
       </button>
     </div>
   </Modal.Body>
 </Modal>
  )
}
